import { SvenskdamStandaloneNewsletterSignup } from '@/svenskdam/components/NewsletterSignup';
import { LabradorComponent } from '@/types/component';

export const SvenskdamLabradorNewsletterSignup: LabradorComponent = ({ type, data, meta }) => {
  return (
    <SvenskdamStandaloneNewsletterSignup
      headline={data.headline}
      description={data.infoText}
      footer={data.integrityText}
      successModal={{
        content: data.successText,
      }}
      submitButton={{
        content: data.submitLabel,
      }}
    />
  );
};
